module.exports = __webpack_public_path__ + "static/img/SplashPage.08f0a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/SplashPage.jpg
// module id = ew51
// module chunks = 44